import iframeResize from 'iframe-resizer/js/iframeResizer';
import Base from '../../_config/base';

class Iframe extends Base {
  constructor(el) {
    super(el);
    const resizableIframe = el.querySelector('[data-iframe-resizer]');

    if (resizableIframe) {
      // Prospective embeds the iframe-resizer child script and requires taggedElement
      iframeResize({ heightCalculationMethod: 'taggedElement', checkOrigin: false }, resizableIframe);
    }
  }
}

Iframe.className = 'Iframe';
export default Iframe;
